module.exports = "https://la-static.prod-my.games/minigames/collection/img/card_row_count.c3f6b4af.svg";